// src/components/SuggestionBox.jsx
import React, { useState } from "react";
import { Lightbulb, Send } from "lucide-react";
import { toast } from "react-toastify";
import api from "../api/api";

export default function SuggestionBox() {
  const [message, setMessage] = useState("");
  const [contact, setContact] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async () => {
    if (sending) return;
    if (message.trim().length < 5) {
      toast.error("Please write a little more before sending.");
      return;
    }
    setSending(true);
    try {
      const res = await api.post("/suggestions", {
        message: message.trim(),
        contact: contact.trim(),
        page: window.location.pathname,
      });
      toast.success(res.data?.message || "Thank you! Your suggestion has been sent.");
      setMessage("");
      setContact("");
    } catch (err) {
      if (err.response?.status === 429) {
        toast.error(err.response?.data?.message || "Too many suggestions. Please try again later.");
      }
    } finally {
      setSending(false);
    }
  };

  return (
    <section id="suggestions" className="px-4 md:px-8 pb-14 md:pb-20">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 md:gap-12 items-center rounded-3xl bg-lilac/60 dark:bg-gray-800/40 border border-black/5 dark:border-white/10 p-6 sm:p-8 md:p-10">
        <div>
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-white dark:bg-gray-800 text-brandviolet-500 dark:text-brandviolet-300 shadow-sm mb-4">
            <Lightbulb className="w-5 h-5" />
          </span>
          <h2 className="font-display font-semibold text-2xl sm:text-3xl">
            Got an idea? Tell us.
          </h2>
          <p className="mt-3 text-muted2 dark:text-gray-400 text-sm md:text-base">
            Missing a service, a feature, or something that could work better? Send us a quick
            suggestion. We read every one.
          </p>
        </div>

        <div className="bg-white dark:bg-gray-800 border border-black/5 dark:border-white/10 rounded-2xl p-4 sm:p-5 shadow-sm">
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            maxLength={1000}
            rows={4}
            placeholder="Write your suggestion here..."
            className="w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 px-3 py-2.5 outline-none focus:ring-2 focus:ring-brandviolet-500/40 resize-none"
          />
          <p className="text-[10px] text-gray-400 text-right mt-1">{message.length}/1000</p>

          <input
            type="text"
            value={contact}
            onChange={(e) => setContact(e.target.value)}
            maxLength={120}
            placeholder="Email or phone (optional, if you want a reply)"
            className="mt-2 w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900 text-sm text-gray-900 dark:text-gray-100 placeholder-gray-400 px-3 py-2.5 outline-none focus:ring-2 focus:ring-brandviolet-500/40"
          />

          <button
            type="button"
            onClick={submit}
            disabled={sending}
            className="mt-3 w-full inline-flex items-center justify-center gap-2 rounded-xl bg-brandviolet-500 hover:bg-brandviolet-600 disabled:opacity-60 text-white text-sm font-semibold py-3 transition-colors"
          >
            {sending ? "Sending..." : "Send suggestion"} <Send className="w-4 h-4" />
          </button>
        </div>
      </div>
    </section>
  );
}